module.exports = __webpack_public_path__ + "static/media/polycon-icon.fd2c6a7a.png";